import BioSection from "components/Screens/Marketplace/Customer/ProfileSection/BioSection";
import OverviewSection from "components/Screens/Marketplace/Customer/ProfileSection/OverviewSection";
import HandsOnExperienceSection from "components/Screens/Marketplace/Customer/ProfileSection/HandsOnExperienceSection";
import SoftwareSkillsSection from "components/Screens/Marketplace/Customer/ProfileSection/SoftwareSkillsSection";
import CertificationsSection from "components/Screens/Marketplace/Customer/ProfileSection/CertificationsSection";
import WorkExperienceSection from "components/Screens/Marketplace/Customer/ProfileSection/WorkExperienceSection";
import EducationSection from "components/Screens/Marketplace/Customer/ProfileSection/EducationSection";

import {
  mapTalentToOverviewItems,
  mapTalentToWorkExperience,
  mapTalentToEducation,
  mapTalentToSoftwareSkills,
  mapTalentToSkillsChips,
  mapTalentToCertifications,
  generateBioFromTalent,
} from "components/Screens/Marketplace/Customer/utils/dataMappers";

import type { TalentProfile } from "components/Screens/Marketplace/Customer/types";

import "components/Screens/Marketplace/Customer/ProfileSection/ProfileContent.scss";

interface ProfileContentProps {
  talent: TalentProfile;
}

export function getAvailableTabs(talent: TalentProfile) {
  const bio = generateBioFromTalent(talent);
  const bioText = Array.isArray(bio) ? bio.join(" ") : bio || "";
  const overviewItems = mapTalentToOverviewItems(talent);
  const handsOnExperience = mapTalentToSkillsChips(talent);
  const softwareSkills = mapTalentToSoftwareSkills(talent);
  const certifications = mapTalentToCertifications(talent);
  const workExperience = mapTalentToWorkExperience(talent);
  const education = mapTalentToEducation(talent);

  const tabs: { id: string; label: string }[] = [];

  if (bioText.trim()) tabs.push({ id: "bio", label: "Bio" });
  if (overviewItems.length > 0) tabs.push({ id: "overview", label: "Overview" });
  if (handsOnExperience.length > 0) tabs.push({ id: "hands-on", label: "Skills" });
  if (softwareSkills.length > 0) tabs.push({ id: "software", label: "Software skills" });
  if (certifications.length > 0) tabs.push({ id: "certifications", label: "Certifications" });
  if (workExperience.length > 0) tabs.push({ id: "work", label: "Work experience" });
  if (education.length > 0) tabs.push({ id: "education", label: "Education" });

  return tabs;
}

function ProfileContent({ talent }: ProfileContentProps) {
  const bio = generateBioFromTalent(talent);
  const bioText = Array.isArray(bio) ? bio.join(" ") : bio || "";
  const overviewItems = mapTalentToOverviewItems(talent);
  const handsOnExperience = mapTalentToSkillsChips(talent);
  const softwareSkills = mapTalentToSoftwareSkills(talent);
  const certifications = mapTalentToCertifications(talent);
  const workExperience = mapTalentToWorkExperience(talent);
  const education = mapTalentToEducation(talent);

  return (
    <div className="profile-content">
      {bioText.trim() && <BioSection bio={bioText} />}
      {overviewItems.length > 0 && <OverviewSection overviewItems={overviewItems} />}
      {handsOnExperience.length > 0 && <HandsOnExperienceSection experience={handsOnExperience} />}
      {softwareSkills.length > 0 && <SoftwareSkillsSection skills={softwareSkills} />}
      {certifications.length > 0 && <CertificationsSection certifications={certifications} />}
      {workExperience.length > 0 && <WorkExperienceSection experience={workExperience} />}
      {education.length > 0 && <EducationSection education={education} />}
    </div>
  );
}

export default ProfileContent;
